import {
  MDP_ECOMMERCE_ACCEPT_URL_NL,
  MDP_ECOMMERCE_ACCEPT_URL_BE,
  MDP_ECOMMERCE_ACCEPT_URL_ECONNECT,
  MDP_ECOMMERCE_PROD_URL_NL,
  MDP_ECOMMERCE_PROD_URL_BE,
  MDP_ECOMMERCE_PROD_URL_ECONNECT,
  MDP_ADMIN_ECOMMERCE_PROD_URL,
  MDP_ADMIN_PARCEL_ACCEPT_URL,
  MDP_ADMIN_PARCEL_PROD_URL,
  MDP_ECOMMERCE_ACCEPT_URL_PPL_CZ,
  MDP_ECOMMERCE_PROD_URL_PPL_CZ,
} from '~/common/config/app-constants'
import { type User } from '~/modules/users/model'

type HostRedirect = RedirectUrl | ErrorMessage

type RedirectUrl = {
  redirectUrl: string
}

type ErrorMessage = {
  errorMessage: string
}

//@todo add unit test
export const getLoginRedirectUrl = (user: User, authPath: string | undefined, loc: Location): HostRedirect => {
  const host = `${loc.protocol}//${loc.host}`

  // First check if the admin domain that is being used is not deprecated
  if (host === MDP_ADMIN_PARCEL_ACCEPT_URL || host === MDP_ADMIN_PARCEL_PROD_URL) {
    return { errorMessage: 'Use dhlecommerce.nl for login-as functionality.' }
  }

  const isProd = host === MDP_ADMIN_ECOMMERCE_PROD_URL
  const businessUnitCode = user.organisationBusinessUnitCode
  const key = `${businessUnitCode}-${isProd ? 'prod' : 'accept'}`

  const urlMap = {
    'ccc-accept': MDP_ECOMMERCE_ACCEPT_URL_ECONNECT,
    'ccc-prod': MDP_ECOMMERCE_PROD_URL_ECONNECT,
    'dhl-be-accept': MDP_ECOMMERCE_ACCEPT_URL_BE,
    'dhl-be-prod': MDP_ECOMMERCE_PROD_URL_BE,
    'dhl-nl-accept': MDP_ECOMMERCE_ACCEPT_URL_NL,
    'dhl-nl-prod': MDP_ECOMMERCE_PROD_URL_NL,
    'ppl-cz-accept': MDP_ECOMMERCE_ACCEPT_URL_PPL_CZ,
    'ppl-cz-prod': MDP_ECOMMERCE_PROD_URL_PPL_CZ,
  } as const

  const redirectUrl: string = urlMap[key] ?? (isProd ? urlMap['dhl-nl-prod'] : urlMap['dhl-nl-accept'])

  return { redirectUrl: `${redirectUrl}${authPath}` }
}
